import { IPwaInstallApiRow, IPwaInstallReportResult } from '../types';

export function parsePwaInstallResponse(payload: unknown): IPwaInstallReportResult {
    if (!Array.isArray(payload) || payload.length === 0) {
        return { status: 'error', bonusCoins: 0, note: 'EmptyResponse' };
    }

    const row = payload[0] as IPwaInstallApiRow;
    const note = typeof row.Note === 'string' ? row.Note : undefined;
    const bonusCoins = typeof row.BonusCoins === 'number' ? row.BonusCoins : Number(row.BonusCoins) || 0;

    if (note === 'AlreadyInstalled') {
        return {
            status: 'already_installed',
            bonusCoins: 0,
            coins: toOptionalNumber(row.Coins),
            freeCoins: toOptionalNumber(row.FreeCoins),
            note,
        };
    }

    if (note === 'Success') {
        return {
            status: bonusCoins > 0 ? 'credited' : 'already_installed',
            bonusCoins,
            coins: toOptionalNumber(row.Coins),
            freeCoins: toOptionalNumber(row.FreeCoins),
            note,
        };
    }

    return {
        status: 'error',
        bonusCoins: 0,
        note: note || 'Unknown',
    };
}

function toOptionalNumber(value: unknown): number | undefined {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === 'string' && value.trim() !== '' && Number.isFinite(Number(value))) {
        return Number(value);
    }
    return undefined;
}
